import React , {useState , useRef , useEffect} from 'react';
import './Login.scss';
import LoginVideo from '../../Videos/login-vid.mp4';
import { Formik ,  Form ,  Field  } from 'formik';
import { LoginValidation } from '../Validation/Validation';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import axios from 'axios';




const Login = () => {

  const navigate = useNavigate();

  
  const apiUrl = 'https://code-sgbackend.vercel.app/api/v1/auth'

  const [passwordHandler , setPasswordHandler] = useState(false)

  const loginValues = {
    email: '',
    password: ''
  }

  const handleLogin = async (values) => {
    const obj = {
      email: values.email,
      password: values.password
    }
    try {
      await axios.post(`${apiUrl}/userSignin` , obj)
      .then((res) => {
        if(res) {
          toast.success(`Logged In as ${res?.data?.data?.user?.email}` );
          localStorage.setItem('userToken' , JSON.stringify(res?.data?.data?.token))
          localStorage.setItem('userDetails' , JSON.stringify(res?.data?.data?.user))
          navigate('/')
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.error('Error occurred during POST request:', err);
        
      });
    } catch (error) {
      
    }
  }


  return (
    <div className="Login main-login-screen bg-hometext-white h-screen">
      <div className="grid grid-cols-2 h-full">
        <div className="left-login-video-sec  overflow-hidden h-full">
          <video src={LoginVideo} autoPlay muted loop controls={false} width="100%" className='h-full object-cover' height="100%"></video>
        </div>
        <div className="right-forms-section-login flex items-center justify-center">
            <div className="inner-form-section-login max-w-[70%] w-full">
              <div className="top-header-login mb-10">
                <h2 className='text-homeblack text-6xl font-DmSans leading-normal font-bold mb-2'>Login</h2>
                <p className='text-homeblack font-DmSans'>& Enjoy exclusive fetaures and many more</p>
              </div>
              <Formik
                validationSchema={LoginValidation}
                initialValues={loginValues}
                onSubmit={(values) => handleLogin(values)}
              >
                {({  errors, touched }) => (
                  <Form>
                    <div className="top-firs-last-name flex flex-col gap-6">
                      <div className="first-name-section">
                        <div className="top-form-name-section grid grid-cols-2 gap-6">
                          <div className="email-section col-span-2">
                            <div className="form-inputsec relative">
                              <Field type="email" name="email" placeholder='Email'
                                className={`outline-none border focus:border-greenYellow focus:bg-greenYellow focus:bg-opacity-10 duration-300 py-3 px-5 rounded-lg bg-transparent font-Manrope w-full text-homeblack font-semibold ${errors.email && touched.email ? 'inputError border-red-500 border-opacity-100 bg-red-500 bg-opacity-10 placeholder:text-red-500 text-red-500' : 'text-homeblack font-semibold border-homeblack border-opacity-70 placeholder:text-homeblack'}`} 
                              />
                            </div>
                          </div>
                          <div className="email-section col-span-2">
                            <div className="form-inputsec relative">
                              <Field type={passwordHandler ? 'text' : 'password'} name="password" placeholder='Password'
                                className={`outline-none border focus:border-greenYellow focus:bg-greenYellow focus:bg-opacity-10 duration-300 py-3 px-5 rounded-lg bg-transparent font-Manrope w-full text-homeblack font-semibold ${errors.password && touched.password ? 'inputError border-red-500 border-opacity-100 bg-red-500 bg-opacity-10 placeholder:text-red-500 text-red-500' : 'text-homeblack font-semibold border-homeblack border-opacity-70 placeholder:text-homeblack'}`} 
                              />
                               <div className="absolute-icon left-side-contact absolute top-[10px] right-4">
                                  <button type='button' onClick={() => setPasswordHandler(!passwordHandler)}><i className={`bi ${passwordHandler ? 'bi-eye-slash' : 'bi-eye'} text-xl text-homeblack`}></i></button>
                               </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bottom-form-submitter mt-6 rounded-lg overflow-hidden relative group">
                        <button type='submit' className='w-full py-3 px-4 rounded-lg font-DmSans text-homeblack bg-greenYellow font-semibold hover:bg-hometext-homeblack hover:text-homeblack text-lg duration-500'>Login</button>
                    </div>
                  </Form>
                )}
              </Formik>
              <div className="bottom-already-section mt-2">
                <div className="already-text-button">
                  <p className='text-sm font-Manrope text-homeblack '>Don't Have an Account? <button type="button" className='font-semibold text-homePrimary text-base ml-2' onClick={() => navigate('/register')}>Register</button></p>
                </div>
              </div>
            </div>
        </div>

      </div>
    </div>
  );
}


export default Login;
